// MUST be the first import — disables Zod 4.x's JIT validator compiler
// before any schema-using module is imported. apps/mentor aliases
// @frontend → frontend/src and pulls in hooks like useSessions /
// useCreateSession that transitively register schemas. Without this line,
// Safari's JSC rejects the JIT-generated validator bodies with
// "Unexpected token '{'" at every parse() call. See
// frontend/src/zod-config.ts for the full rationale.
import '@frontend/zod-config'

// Side-effect import: initialises the shared i18next instance (de/fr/en)
// used by every @frontend hook and component this app reuses.
import '@frontend/i18n'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
// Design tokens FIRST — the generated --color-* / surface CSS vars that the
// Tailwind theme (neutral-*, accents, hairlines) resolves against. index.css
// only re-exports a few glow vars for the shadcn layer; without tokens.css the
// design-token classes fall back to currentColor (black borders). The main app
// loads these in frontend/src/main.tsx; satellites must too (compatibility does
// it via compat.css). MUST precede index.css so the vars exist before use.
import '@frontend/design/tokens.css'
import '@frontend/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
